import React, { useState, useEffect } from 'react';
import { Lock, X, MessageCircle } from 'lucide-react';
import api from '../services/api';

/**
 * ========================================
 * 🔒 PROTECCIÓN TEMPORAL DE REGISTRO
 * ========================================
 * 
 * Este modal requiere una contraseña para acceder al registro.
 * Contraseña actual: "Reg2025"
 * 
 * PARA DESHABILITAR ESTA PROTECCIÓN:
 * 1. Ir a /app/frontend/src/pages/LandingPage.js
 * 2. Buscar: REGISTER_PASSWORD_ENABLED
 * 3. Cambiar a: const REGISTER_PASSWORD_ENABLED = false;
 * 
 * También deshabilitar en:
 * - /app/frontend/src/pages/LoginPage.js (mismo proceso)
 * 
 * ========================================
 */

const REGISTER_ACCESS_PASSWORD = "Reg2025";

const RegisterPasswordModal = ({ isOpen, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');

  useEffect(() => {
    if (isOpen) {
      loadWhatsAppNumber();
    }
  }, [isOpen]);

  const loadWhatsAppNumber = async () => {
    try {
      const response = await api.get('/api/whatsapp/config');
      if (response.data && response.data.phone) {
        setWhatsappNumber(response.data.phone);
      }
    } catch (error) {
      console.error('Error cargando número WhatsApp:', error);
    }
  };

  const handleWhatsAppClick = () => {
    if (!whatsappNumber) {
      alert('No hay número de WhatsApp configurado');
      return;
    }
    
    const cleanPhone = whatsappNumber.replace(/[^0-9]/g, '');
    const message = encodeURIComponent('Hola, necesito la contraseña para registrarme en EasyTickets');
    window.open(`https://wa.me/${cleanPhone}?text=${message}`, '_blank');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === REGISTER_ACCESS_PASSWORD) {
      setError('');
      onSuccess();
    } else {
      setError('Contraseña incorrecta');
      setPassword('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex p-4 bg-blue-100 rounded-full mb-4">
            <Lock className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Modo Tester
          </h2>
          <p className="text-gray-600 mb-4">
            Pide el Password al WhatsApp
          </p>

          {/* Botón de WhatsApp */}
          {whatsappNumber && (
            <button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-semibold transition-all mb-4"
            >
              <MessageCircle className="w-5 h-5" />
              Solicitar Password por WhatsApp
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Contraseña de acceso
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Ingresa la contraseña"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              autoFocus
            />
            {error && (
              <p className="text-red-600 text-sm mt-2">❌ {error}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
          >
            Verificar
          </button>
        </form>

        <p className="text-xs text-gray-500 text-center mt-4">
          Contacta por WhatsApp para obtener el acceso
        </p>
      </div>
    </div>
  );
};

export default RegisterPasswordModal;
